import { Component, ElementRef, EventEmitter, HostListener, inject, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { SpinnerService } from '@drc-eca/eca-lrc-common-ui';
import { NgStyle } from '@angular/common';
import { ImageZoomComponent } from './zoom/zoom.component';

@Component({
  selector: 'eca-alerts-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  imports: [ImageZoomComponent, NgStyle]
})
export class ImageViewerComponent {
  private spinnerService = inject(SpinnerService);

  currentRegions: Region[];
  overlayBoxes: Region[];
  isZoomed: boolean;
  currentImageSource: string;
  loading = false;


  @ViewChildren('formImage') image: QueryList<ElementRef<HTMLImageElement>>;

  @Input() set src(imageSource: string) {
    if (imageSource) {
      this.loading = true;
      this.overlayBoxes = [];
    }
    this.currentImageSource = imageSource;
  }

  @Input() set regions(regions: Region[]) {
    this.currentRegions = regions;
    this.updateOverlayBoxes();
  }

  @Input() showNoData: boolean;

  @Output() loadedImage = new EventEmitter();

  @HostListener('window:resize', ['$event'])
  onResize(/* event: Event */): void {
    this.updateOverlayBoxes();
  }

  onImageLoad() {
    this.loading = false;
    this.loadedImage.emit();

    // We seem to need to wait a small amount of time so that once the image is loaded we can get its bounding rectangle
    setTimeout(() => {
      this.updateOverlayBoxes();
    }, 0);
  }

  onImageError() {
    this.showNoData = true;
    this.spinnerService.hide();
  }

  onZoomEvent(event) {
    if (event.type === 'zoom-in') {
      this.isZoomed = true;
    }

    if (event.type === 'zoom-out-end') {
      this.isZoomed = false;
    }
  }

  updateOverlayBoxes() {
    if (this.loading || !this.image?.first?.nativeElement) {
      return;
    }

    const ele = this.image.first.nativeElement;
    const rect = ele.getBoundingClientRect();

    const naturalWidth = ele.naturalWidth || 1600;
    const naturalHeight = ele.naturalHeight || 2071;

    const scaleX = rect.width / naturalWidth * (this.isZoomed ? 2 : 1);
    const scaleY = rect.height / naturalHeight * (this.isZoomed ? 2 : 1);

    if (scaleX !== 0 && scaleY !== 0 && this.currentRegions) {
      this.overlayBoxes = this.currentRegions.map((region) => {
        return {
          x: region.x * scaleX,
          y: region.y * scaleY,
          width: region.width * scaleX,
          height: region.height * scaleY
        }
      });
    } else {
      this.overlayBoxes = [];
    }
  }
}

export class Region {
  x: number;
  y: number;
  width: number;
  height: number;
}
